var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:phone-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.80163 7.9074L8.55517 8.15278C8.55517 8.15278 7.96855 8.73561 6.36792 7.1442C4.7673 5.55278 5.35392 4.96995 5.35392 4.96995L5.50884 4.81503C5.8918 4.43478 5.92809 3.82378 5.59388 3.37745L4.91138 2.46582C4.49755 1.91332 3.69859 1.8402 3.22463 2.31145L2.37421 3.15645C2.13967 3.39045 1.98259 3.6927 2.00155 4.02853C2.0503 4.88815 2.43921 6.73686 4.60805 8.89378C6.9085 11.1807 9.06705 11.2717 9.94942 11.1894C10.2289 11.1634 10.4716 11.0214 10.6671 10.8264L11.4363 10.0616C11.9563 9.5454 11.81 8.65978 11.1449 8.29849L10.1103 7.7357C9.67371 7.49845 9.14288 7.56832 8.80163 7.9074Z",
    fill: "#29406C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7d1f5029eea70f1a9544cb6da53c2c33.svg";
export { ForwardRef as ReactComponent };